import React from 'react';
import ReactDOM from "react-dom";
import Index from "./pages";

window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const App = () => {
    return (
        <Index />
    );
}

export default App;

const app = document.getElementById('app');
if (app) {
    ReactDOM.render(<App />, app);
}
